/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import { useFormikContext } from 'formik'
import InputMask from 'react-input-mask'
import tokens from '../../../../../styles/tokens.json'
import { Styles } from '../../../../../types'
import { FormValues } from '../../models'

const styles: Styles = {
  readOnly: (theme) => ({
    '& .MuiInputBase-root': {
      '& input': {
        fontWeight: theme.typography.fontWeightLight,
      },
      '&.Mui-focused input': {
        color: tokens.colors.halfWhite,
      },
      '&:not(.Mui-focused) input': {
        paddingRight: '0rem',
        paddingLeft: '0rem',
      },
      '&.MuiOutlinedInput-root fieldset': {
        border: 'none',
      },
    },
  }),
}

type FormPhoneTextFieldProps = TextFieldProps & {
  maxLength?: number
  name: string
  readonly?: boolean
}

const FormPhoneTextField = ({
  label,
  name,
  maxLength,
  readonly,
  required,
  ...rest
}: FormPhoneTextFieldProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { errors, handleChange, submitCount, touched, values } =
    useFormikContext<FormValues>()

  return (
    <InputMask
      mask="(999) 999-9999"
      value={values[name] || ''}
      onChange={handleChange}>
      <TextField
        {...rest}
        id="businessPhone"
        sx={readonly ? styles.readOnly : undefined}
        fullWidth
        inputProps={{
          'aria-required': required,
          maxLength,
          readOnly: readonly,
          'data-testid': 'Inp_ContactPreferences_BusinessPhoneValue',
        }}
        name={name}
        placeholder="(111) 111-1111"
        required={required}
        autoComplete="off"
        error={(touched[name] || submitCount > 0) && Boolean(errors[name])}
        helperText={
          (touched[name] || submitCount > 0) && errors[name]?.toString()
        }
        data-testid={`${name}-test-id`}
      />
    </InputMask>
  )
}

export default FormPhoneTextField
